import {
  Paper,
  Group,
  Text,
  ThemeIcon,
  Tooltip,
  Skeleton,
  Box,
  UnstyledButton,
} from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";

export interface BillingStatCardProps {
  title: string;
  value: string | number;
  description: string;
  icon: React.ReactNode;
  color: string;
  tooltip: string;
  isLoading?: boolean;
  subline?: React.ReactNode;
  onClick?: () => void;
}

export function BillingStatCard({
  title,
  value,
  description,
  icon,
  color,
  tooltip,
  isLoading,
  subline,
  onClick,
}: BillingStatCardProps) {
  const cardBody = (
    <Paper
      withBorder
      p="md"
      radius="md"
      style={{
        cursor: onClick ? "pointer" : "default",
        height: "100%",
        transition: "border-color 120ms",
      }}
    >
      <Group justify="space-between" mb="xs" wrap="nowrap">
        <Group gap={6} wrap="nowrap">
          <Text size="sm" c="dimmed" fw={500}>
            {title}
          </Text>
          <Tooltip label={tooltip} multiline w={280} withArrow>
            <IconInfoCircle
              size={14}
              style={{ color: "var(--mantine-color-gray-5)" }}
            />
          </Tooltip>
        </Group>
        <ThemeIcon variant="light" color={color} size="lg">
          {icon}
        </ThemeIcon>
      </Group>
      {isLoading ? (
        <Skeleton height={28} width={60} mb={4} />
      ) : (
        <Text size="xl" fw={700}>
          {value}
        </Text>
      )}
      <Text size="xs" c="dimmed" mt={2}>
        {description}
      </Text>
      {subline && <Box mt={6}>{subline}</Box>}
    </Paper>
  );

  if (onClick) {
    return (
      <UnstyledButton
        onClick={onClick}
        style={{ display: "block", width: "100%", textAlign: "left" }}
      >
        {cardBody}
      </UnstyledButton>
    );
  }
  return cardBody;
}
